/**
 * Utility for validating CSV files and formatting file sizes
 */
export class CSVFileValidator {
  private static readonly MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

  /**
   * Validate a CSV file for upload
   * @returns Error message if invalid, null if valid
   */
  static validateFile(file: File): string | null {
    // Validate file type
    if (file.type !== 'text/csv' && !file.name.toLowerCase().endsWith('.csv')) {
      return 'Please select a CSV file';
    }

    // Validate file size
    if (file.size > this.MAX_FILE_SIZE) {
      return 'File size must be less than 5MB';
    }

    return null;
  }

  /**
   * Format file size for display
   */
  static formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }
}
